import { translateFunc } from "./translateFunc";

export const simplifyAndTranslateLabels = (t, item, fields) => {
  return Object.entries(item).reduce((acc, [key, value]) => {
    let parsed;

    try {
      parsed = JSON.parse(value);
    } catch {
      acc[key] = value;
      return acc;
    }

    const isLabeledValue =
      parsed &&
      typeof parsed === 'object' &&
      'label' in parsed &&
      'value' in parsed;

    if (isLabeledValue) {
      const field = fields.find(f => f.name === key);

      acc[key] = field?.type !== 'date'
        ? translateFunc(t, `basicFormStepByStep.fieldTranslate.${field.type}.${key}.${parsed.value}`, parsed.label)
        : parsed.label;
    } else {
      acc[key] = value;
    }

    return acc;
  }, {});
};